import {
  REGISTER_REQUEST,
  REGISTER_SUCCESS,
  REGISTER_FAILURE,
  CLEAR_REGISTER_ERROR
} from './registerActionTypes'

const initialState = {
  loading: false,
  error: null,
  success: false,
  user: null
}

export const registerReducer = (state = initialState, action) => {
  switch (action.type) {
    case REGISTER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false
      }
    case REGISTER_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        user: action.payload,
        error: null
      }
    case REGISTER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false
      }
    case CLEAR_REGISTER_ERROR:
      return {
        ...state,
        error: null
      }
    default:
      return state
  }
}

export default registerReducer
